<template>
    <Head title="Riwayat Kunjungan" />
    <div class="card card-outline card-primary">
        <div class="card-header">
            <h3 class="card-title">RIWAYAT KUNJUNGAN - {{ this.tagihan.nama }} | {{ this.tagihan.rek }}</h3>
            <div class="card-tools">
                <Link href="/tagihan" class="btn btn-tool"><i class="fas fa-times"></i></Link>
            </div>
        </div>
        <div class="card-body table-responsive">
            <data-table :columns="columns" :ajax="ajax" id="dt-table" :order="[1, 'desc']"></data-table>
        </div>
    </div>
</template>
  
<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from '@inertiajs/vue3'
import DataTable from '@/Forms/DataTable'

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        DataTable,
    },
    props: {
        tagihan: Object,
    },
    data() {
        return {
            columns: [
                { title: 'No', data: 'DT_RowIndex', orderable: false, searchable: false },
                { title: 'Tgl Kunjungan', data: 'created_at' },
                { title: 'Tgl Janji', data: 'tgl_janji' },
                { title: 'Penagihan', data: 'user.name' },
                { title: 'Keterangan', data: 'keterangan' },
                { title: 'Koordinat', data: 'koordinat' },
                { title: 'Aksi', data: 'action', orderable: false, searchable: false, }
            ],
            ajax: {
                url: '/datatables/'+this.tagihan.rek+'/riwayat',
                data: function (d) {
                    d.kantor = $("input[name=kantor]").val()
                    d.team = $("select[name=team]").val()
                    d.centang = $("select[name=centang]").val()
                },
            },
        }
    },
}
</script>
 